import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosAuth } from "../config/axiosInstance";
import { PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL } from "../config/api_config";
import { resolveCourseId, resolveModuleSlug } from "../utilities/videoPlayerApi";

export const fetchFeedback = createAsyncThunk(
    'feedback/fetchFeedback',
    async ({ course_id, module_slug, video_id, lesson_id, question, answer }, { getState }) => {
        const courseId = resolveCourseId(getState(), course_id);
        const moduleSlug = resolveModuleSlug(module_slug);
        const response = await axiosAuth.post(
            `${PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL}/api/v1/courses/${courseId}/modules/${moduleSlug}/lessons/${lesson_id}/quiz/assessment`,
            { question, answer, video_id: video_id || null }
        );
        return response.data;
    }
);

const feedbackSlice = createSlice({
    name: 'feedback',
    initialState: {},
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchFeedback.fulfilled, (state, action) => action.payload);
    },
});

export const selectFeedback = (state) => state.feedback;
export default feedbackSlice.reducer;
